const headerElement = document.querySelector('.site-header');
const topHeaderElement = document.querySelector('.yhteystietoheader');
const root = document.documentElement;

let topHeaderHeight = 0;

function updateHeaderHeight() {
    const headerHeight = headerElement.offsetHeight;
    root.style.setProperty('--headerheight', `${headerHeight}px`);

    topHeaderHeight = topHeaderElement ? topHeaderElement.offsetHeight : 0;
    root.style.setProperty('--topheaderheight', `${topHeaderHeight}px`);
}

updateHeaderHeight();

document.addEventListener('DOMContentLoaded', () => {
    updateHeaderHeight();

    // Observe actual size changes
    const resizeObserver = new ResizeObserver(() => {
        window.addEventListener('resize', () => {
            setTimeout(updateHeaderHeight, 100); // gives CSS time to apply
        });
    });

    resizeObserver.observe(headerElement);

    if (topHeaderElement) {
        resizeObserver.observe(topHeaderElement);
    }

    // Scroll behavior
    window.addEventListener('scroll', () => {
        if (window.scrollY > topHeaderHeight) {
            headerElement.classList.add('scrolled');
        } else {
            headerElement.classList.remove('scrolled');
        }
    });
});
